module.exports = __webpack_public_path__ + "img/g4.9193b016.png";